<template>
    <div style="
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    background: #F0F5F4;
    scrollbar-width: none;
     -ms-overflow-style: none;">
        <div id="searchBar"
            style="width: 95%;display: flex;align-items: center;padding: 10px 0;justify-content: space-between;">
            <div style="display: flex;align-items: center;">
                <div>
                    回收点:
                </div>

                <el-dropdown>
                    <span class="el-dropdown-link">
                        全部<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>黄金糕</el-dropdown-item>
                        <el-dropdown-item>狮子头</el-dropdown-item>
                        <el-dropdown-item>螺蛳粉</el-dropdown-item>
                        <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                        <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-input v-model="input" style="width: 200px;margin-left: 10px;" placeholder="请输入关键字"></el-input>
            </div>
            <div style="display: flex;align-items: center;">
                <el-button @click="enterNavigate" type="primary">进入导航</el-button>
                <el-button type="danger">结束回收</el-button>
            </div>
            
        </div>
        <div :style="{ height: orderHeight + 'px' }" style="width:100%;display: flex;flex-direction: column;align-items: center;overflow: auto;  scrollbar-width: none;
     -ms-overflow-style: none;">
            <div v-for="item, index in orderList"
                style="width: calc(95% - 20px);background: white;border-radius: 10px;margin-bottom: 10px;flex-shrink: 0;display: flex;flex-direction: column;padding: 10px;">
                <div style="display: flex;justify-content: space-between;">
                    <div style="display: flex;align-items: center;">
                        <div>{{ item.taddress.contact + (item.taddress.sex == 1 ? '先生' : '女士') }} </div>
                        </div>
                    <div style="display: flex;align-items: center;">
                        <div style="font-size: 15px;font-weight: 700;">
                            {{ item.address }}
                        </div>
                        <div style="font-size: 15px;font-weight: 700;margin-left: 5px;color: grey;">
                            {{ item.taddress.detailAddress }}
                        </div>
                    </div>
                </div>
                <!-- <div style="display: flex;align-items: center;"> -->
                <div style="font-size: 20px;font-weight: 700;text-align: left;">{{ item.typeStr }}</div>
                <div style="display: flex;align-items: center;">
                    <div style="font-size: 20px;font-weight: 700;">预估重量:</div>
                    {{ item.estimatedWeight }}
                    kg
                </div>
                <div style="display: flex;align-items: center;">
                    <div style="font-size: 20px;font-weight: 700;">预计支出:</div>
                    {{ item.estimatedRevenue }}
                </div>
                <!-- </div> -->
            </div>

        </div>
    </div>
</template>

<style scoped></style>

<script>
import request from "../axios/request";
export default {
    data() {
        return {
            orderList: [],
            orderHeight: 0,
            input: null
        }
    },
    mounted() {

        let searchBar = document.getElementById("searchBar")
        const resizeObserver = new ResizeObserver((entries) => {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    for (const entry of entries) {

                        this.orderHeight = window.innerHeight - searchBar.clientHeight;

                    }
                });
            })

        });
        resizeObserver.observe(document.getElementById("searchBar"));
        this.getAllRecycleOrder()
    },
    methods: {
        enterNavigate(){
            window.location.href = this.$store.state.navigateUrl
        },
        async getAllRecycleOrder() {
            let res = await request({
                url: "/order/api/getOrderListByAddress",
                method: "GET"
            })
            if (res.data.status == 200) {
                this.orderList = res.data.data
            }
        }
    }
}
</script>